// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bed-setup-counter .minus-button{border-radius:.25em !important;border-top-right-radius:0 !important;border-bottom-right-radius:0 !important}.bed-setup-counter .plus-button{border-radius:.25em !important;border-top-left-radius:0 !important;border-bottom-left-radius:0 !important}.bed-setup-counter .qty-input{border-radius:0 !important;border-right:0 !important;border-left:0 !important;text-align:center}", ""]);
// Exports
module.exports = exports;
